export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center gap-2 px-4" data-testid="not-found-page">
      <h1 className="font-heading text-3xl font-semibold">404</h1>
      <p className="text-muted-foreground">This page does not exist.</p>
    </div>
  );
}
